import getAPI from "@API/index";

export const deleteCode = (id) => {
  return (dispatch) => {
    getAPI()
      .request({
        method: "delete",
        url: `/api/code/${id}`,
      })
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
  };
};
